import { render } from "./AscentFooter.vue?vue&type=template&id=4db08ef2&scoped=true"
import script from "./AscentFooter.vue?vue&type=script&lang=js"
export * from "./AscentFooter.vue?vue&type=script&lang=js"

import "./AscentFooter.vue?vue&type=style&index=0&id=4db08ef2&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db08ef2"]])

export default __exports__